import React from 'react';
import { View, Dimensions, Image } from 'react-native';
import {withRouter} from 'react-router-dom';
import { compose } from "redux";
import { connect } from 'react-redux';

import { logoutUser } from "../../redux/actions";

import {ButtonImage, ButtonImageText} from "..";

import Colors from "../../constants/Colors";
import { drawerConfig } from './DrawerConfig';

class Drawer extends React.Component {

    state = {
        dimensions: null
    };

    handleResize = (dimensions) => {
        this.setState({ dimensions: dimensions });
    };

    componentDidMount() {
        Dimensions.addEventListener("change", this.handleResize)
    }

    componentWillUnmount() {
        Dimensions.removeEventListener("change", this.handleResize);
    }

    render() {

        return(
            <View style={{
                alignItems: 'center',
                flex: 1,
                width: 180,
                maxWidth: 180,
                minWidth: 180,
                maxHeight: 400,
                borderRadius: 8,
                margin: 20,
                // height: this.state.dimensions === null ? '100%' : this.state.dimensions.window.height,
                backgroundColor: Colors.tabBarNavigationBackground
            }}>

                <Image
                    source={require('../../img/logos/logo-drawer.png')}
                    style={{ height: 100, width: '80%', marginTop: 12 }}
                    resizeMode={'contain'}
                />

                {
                    drawerConfig.map((item, index) => {
                        return (
                            <ButtonImageText
                                key={index.toString()}
                                text={item.name}
                                onPress={() => this.props.history.push(item.route)}
                                propsContainerStyle={{ width: '100%' }}
                            />
                        )
                    })
                }

                <ButtonImageText
                    text={"Logout"}
                    onPress={async () => {
                        console.log('logout user!')
                        this.props.logoutUser();
                        this.props.history.replace('/', "urlhistory");
                    }}
                    propsContainerStyle={{ width: '100%' }}

                />

                {/*<View style={{ flex: 1, width: '100%', minHeight: 60, justifyContent: 'flex-end', alignItems: 'center', paddingBottom: 12 }}>*/}
                {/*    <ButtonImage*/}
                {/*        onPress={() => window.open("https://www.i9acao.com.br")}*/}
                {/*        imageSource={require('../../img/logos/i9-logo-white.png')}*/}
                {/*        imagePropsStyle={{ height: 60, width: '90%', alignSelf: 'center' }}*/}
                {/*    />*/}
                {/*</View>*/}
            </View>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

export default compose(
    withRouter,
    connect(mapStateToProps, { logoutUser }),
)(Drawer);
